<div class="historical-graph-container content">
  <div class="menu-bar">
    Historical Graph
    <div>
      <button
        class="menu-bar--right-button-close"
        (click)="closeWidget()"
      ></button>
    </div>
  </div>

  <div class="historical-graph-selects" style="line-height: 0.6rem">
    <div style="width: 4.5rem; margin: 5px" class="select-container">
      <app-selector
        [passedItems]="currencyPairs"
        [isSearch]="true"
        [defaultValue]="currencyPairs[0]"
        (valueEmitter)="onCurrencyPairChanged($event.value)"
      ></app-selector>
    </div>

    <div style="width: 6.5rem; margin: 5px" class="select-container">
      <app-selector
        [passedItems]="instrumentsOptions"
        [isSearch]="false"
        [defaultValue]="'Spot'"
        (valueEmitter)="onInstrumentChanged($event.value)"
      ></app-selector>
    </div>

    <div
      style="width: 3rem; margin: 5px"
      *ngIf="selectedInstrument === 'ForwardMid'"
      class="select-container"
    >
      <app-selector
        [passedItems]="tenorsArray"
        [isSearch]="false"
        (valueEmitter)="onTenorChanged($event.value)"
      ></app-selector>
    </div>

    <!-- <div
      style="width: 2.5rem; margin: 5px"
      *ngIf="selectedInstrument === 'volatility'"
      class="select-container"
    >
      <app-selector
        [passedItems]="objectKeysToArray(this.deltas)"
        [isSearch]="false"
        [isFormControl]="false"
        (valueEmitter)="this.selectedDelta = this.deltas[$event]"
        [defaultValue]="'d1'"
      ></app-selector>
    </div> -->

    <!-- <div style="width: 3rem; margin: 5px" class="select-container">
      <app-selector
        [passedItems]="objectKeysToArray(this.sides)"
        [isSearch]="false"
        [isFormControl]="false"
        (valueEmitter)="this.selectedSide = this.sides[$event]"
        [defaultValue]="'Bid'"
      ></app-selector>
    </div> -->
  </div>

  <div
    class="historical-graph-chart"
    [ngStyle]="{
      width: graphWidth + 30 + 'px',
      height: graphHeight + 30 + 'px'
    }"
  >
    <div
      *ngFor="let yTick of yTicks"
      class="historical-graph-chart-y-line"
      [ngStyle]="{ top: yTick.y + 'px', width: graphWidth + 'px' }"
    ></div>

    <div
      *ngFor="let xTick of xTicks"
      class="historical-graph-chart-x-line"
      [ngStyle]="{ left: xTick.x + 'px', height: graphHeight + 'px' }"
    ></div>

    <div
      *ngFor="let xTick of xTicks"
      class="historical-graph-chart-x-tick historical-graph-chart-x-tick--transform"
      [ngStyle]="{ left: xTick.x - 25 + 'px', top: graphHeight + 10 + 'px' }"
    >
      {{ formatDate(xTick.tick) }}
    </div>

    <div
      *ngFor="let yTick of yTicks"
      class="historical-graph-chart-y-tick"
      [ngStyle]="{ top: yTick.y + 'px', left: graphWidth + 5 + 'px' }"
    >
      {{ yTick.tick }}
    </div>

    <div class="historical-graph-chart-currency-pair-label">
      {{ pairToLabel(selectedCurrencyPair) }}
      <div
        *ngIf="noDataMessage"
        class="historical-graph-chart-currency-pair-label--no-data"
      >
        {{ noDataMessage }}
      </div>
    </div>

    <svg [ngStyle]="{ width: graphWidth + 'px', height: graphHeight + 'px' }">
      <defs>
        <linearGradient id="grad1" x1="0" x2="0" y1="0" y2="1">
          <stop offset="0%" stop-color="#fff" stop-opacity=".25" />
          <stop offset="100%" stop-color="#fff" stop-opacity="0" />
        </linearGradient>
      </defs>
      <path fill="url(#grad1)" [attr.d]="areaCoords" />
      <path
        fill="transparent"
        stroke="#fff"
        stroke-width="1"
        [attr.d]="lineCoords"
      />
    </svg>
  </div>
</div>
